import { useFacetContext, useRouterContext } from '../context/PlpContext';

export const useAnalyticsData = () => {
  const { query } = useRouterContext();
  const facetContext = useFacetContext();
  const { type } = query;

  let pageType = 'search results';

  if (type === 'browse' || type === 'brand') {
    pageType = 'product list page grid';
  }

  return {
    pageType,
    facetContext,
  };
};
